import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function login() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + '/admin/dashboard';
  window.location.href =
    'https://auth.emergentagent.com/?redirect=' + encodeURIComponent(redirectUrl);
}

export async function logout() {
  try {
    await api.post('/auth/logout');
  } catch (e) {
    // ignore
  }
}

export async function fetchMe() {
  const res = await api.get('/auth/me');
  return res.data;
}

export async function createSession(sessionId) {
  const res = await api.post('/auth/session', { session_id: sessionId });
  return res.data;
}
